import React, {
  useEffect,
  useRef,
  useState,
  // useCallback,
} from "react";
import makeStyles from "@mui/styles/makeStyles";
import Paper from "@mui/material/Paper";
// import Popover from "@mui/material/Popover";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
// import TablePagination from "@mui/material/TablePagination";
import { TablePagination } from "@mui/material";
// import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import DeleteIcon from "@mui/icons-material/Delete";

// import { useModuleGroups, useModuleGroupDelete } from "./moduleGroupsService";
import DeleteModuleGroupDialog from "./DeleteModuleGroupDialog";
import { notBlank } from "../util/ext";
// import { useMediaTable } from "../creator-application/common/use-mediaTable";
import { Link, useResolvedPath } from "react-router-dom";
import {
  ascend,
  descend,
  length,
  equals,
  sort,
  sortBy,
  compose,
  toLower,
  prop,
  reverse,
} from "ramda";

const useStyles = makeStyles(theme => ({
  root: {
    width: "calc(100% + 12px)",
    marginLeft: "-6px",
    border: "white",
    borderRadius: "20px",
  },

  container: {
    height: "calc(100vh - 350px)",
  },

  contentCell: {
    width: "33%",
    paddingRight: theme.spacing(3),
  },

  title: {
    color: "#127DA9",
    width: "33%",
  },

  organization: {
    width: "25%",
  },

  cell: {
    minWidth: 30,
    // maxWidth: 150,
    padding: 0,
  },

  cellRoot: {
    border: "none",
    padding: "8px 0",
  },

  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },

  deleteCell: {
    width: "10%",
  },

  popoverPaper: {
    borderRadius: "20px",
    padding: "5px 12px",
    margin: "0",
    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.15)",
  },

  popoverText: {
    fontStyle: "italic",
    fontSize: "10px",
  },
}));

const ModuleGroupsTable = props => {
  const url = useResolvedPath(".").pathname;

  const {
    moduleGroupsList,
    page,
    rowsPerPage,
    onPageChange,
    onModuleGroupDelete,
    total,
    onScrollVisible,
  } = props;

  const classes = useStyles();

  const [orderedList, setOrderedList] = useState(moduleGroupsList);

  useEffect(() => {
    console.log("table: ", moduleGroupsList);
    setOrderedList(moduleGroupsList);
  }, [moduleGroupsList]);

  //-- Handle Table Sort
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("");
  const handleRequestSort = orderBy => {
    const newOrder = equals(order, "asc") ? "desc" : "asc";
    setOrder(newOrder);

    const newOrderedList = comparator(newOrder)(orderBy)(orderedList);
    setOrderBy(orderBy);
    setOrderedList(newOrderedList);
  };

  const comparator = order => orderBy => {
    return equals(order, "asc") ? sortByAsc(orderBy) : sortByDesc(orderBy);
  };

  const sortByAsc = orderBy =>
    equals(orderBy, "moduleGroupName")
      ? sortBy(compose(toLower, prop(orderBy)))
      : sort(ascend(compose(length, prop(orderBy))));

  const sortByDesc = orderBy =>
    equals(orderBy, "moduleGroupName")
      ? compose(reverse, sortBy(compose(toLower, prop(orderBy))))
      : sort(descend(compose(length, prop(orderBy))));

  //-- Track if the scroll bar is visible
  const tableContainerEl = useRef(null);
  useEffect(() => {
    if (notBlank(tableContainerEl)) {
      const element = tableContainerEl.current;
      const scrollVisible = element.scrollHeight > element.clientHeight;
      onScrollVisible(scrollVisible);
    }
  }, [onScrollVisible, tableContainerEl]);

  //-- Handle Module Group Delete
  const [open, setOpen] = useState(false);
  const [activeModuleGroup, setActiveModuleGroup] = useState({});
  const handleClickDelete = moduleGroup => {
    setActiveModuleGroup(moduleGroup);
    setOpen(true);
  };

  const handleModuleGroupDelete = moduleGroupId => {
    onModuleGroupDelete(moduleGroupId);
    setOpen(false);
    setActiveModuleGroup({});
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  return (
    <Paper elevation={0} className={classes.root}>
      <DeleteModuleGroupDialog
        moduleGroup={activeModuleGroup}
        open={open}
        handleClickClose={handleClickClose}
        handleModuleGroupDelete={handleModuleGroupDelete}
      />
      <TableContainer ref={tableContainerEl} className={classes.container}>
        <Table stickyHeader aria-label="Module Groups">
          <TableHead>
            <TableRow>
              <TableCell
                key="module-group-id"
                classes={{
                  root: classes.contentCell,
                  stickyHeader: classes.row,
                }}
                style={{ paddingLeft: "30px" }}
              >
                Module Group ID
              </TableCell>
              <TableCell
                key="module-group-name"
                classes={{ root: classes.cell }}
              >
                <TableSortLabel
                  active={orderBy === "moduleGroupName"}
                  direction={order}
                  onClick={() => handleRequestSort("moduleGroupName")}
                >
                  Module Group Name
                  {orderBy === "moduleGroupName" ? (
                    <span className={classes.visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell
                key="module-group-modules-total"
                classes={{ root: classes.cell }}
              >
                <TableSortLabel
                  active={orderBy === "modules"}
                  direction={order}
                  onClick={() => handleRequestSort("modules")}
                >
                  # of Modules
                  {orderBy === "modules" ? (
                    <span className={classes.visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell
                className={classes.deleteCell}
                classes={{ root: classes.cell }}
              >
                Delete
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {orderedList
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(moduleGroup => (
                <TableRow key={moduleGroup.id} hover tabIndex={-1}>
                  <TableCell
                    key={"id:" + moduleGroup.id}
                    align="left"
                    className={classes.title}
                    classes={{ root: classes.cellRoot }}
                    style={{ paddingLeft: "30px" }}
                  >
                    <Link
                      to={`${url}/${moduleGroup.id}`}
                      style={{ color: "#127DA9", fontWeight: "400" }}
                    >
                      {moduleGroup.id}
                    </Link>
                  </TableCell>

                  <TableCell
                    key={"module-group-name:" + moduleGroup.id}
                    align="left"
                    className={classes.organization}
                    classes={{ root: classes.cellRoot }}
                  >
                    {moduleGroup.moduleGroupName}
                  </TableCell>

                  <TableCell
                    key={"module-group-modules-total:" + moduleGroup.id}
                    align="left"
                    className={classes.organization}
                    classes={{ root: classes.cellRoot }}
                  >
                    {moduleGroup.modules.length}
                  </TableCell>

                  <TableCell
                    key={"module-group-delete:" + moduleGroup.id}
                    classes={{ root: classes.cellRoot }}
                  >
                    <IconButton
                      aria-label="delete module group"
                      onClick={() => handleClickDelete(moduleGroup)}
                      size="large"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        classes={{
          root: classes.pagination,
        }}
        rowsPerPageOptions={[rowsPerPage]}
        component="div"
        count={total}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, page) => onPageChange(event)}
      />
    </Paper>
  );
};

export default ModuleGroupsTable;
